// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"5311895a","189":"36d72fd3","319":"88ca8bbb","453":"09c00ec6","478":"7910c378","518":"34d87bf1","634":"5dafcc11","653":"f5cac636","716":"b32e6a73","869":"d276fa28","899":"4173eaf8","979":"f889a77a"}[chunkId] + ".chunk.js";
};